import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { InfoProvider } from './Context/index';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <InfoProvider>
        <App />
    </InfoProvider>
);